import { useContext, useMemo } from 'react';
import { BrowserRouter } from "react-router-dom";
import AppLayout from "@crema/core/AppLayout";
import 
// AuthRoutes,
{HPAuthRoutes} from '@crema/utility/AuthRoutes';
import LocaleProvider from "@crema/utility/LocaleProvider";
import CremaThemeProvider from "@crema/utility/CremaThemeProvider";
import CremaStyleProvider from "@crema/utility/CremaStyleProvider";
import ContextProvider from "@crema/utility/ContextProvider";

import CssBaseline from "@material-ui/core/CssBaseline";
import InfoViewContextProvider from "@crema/core/InfoView/InfoViewContext";
import { CupBookingContextProvider } from "modules/hp/CupBooking/BookingContext/CupBookingContext";
import { AppContext } from '@crema';

// import { useOnPageLeave } from "modules/hp/common/Utils";
// import { AuthService } from "api/Auth";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import itLocale from 'date-fns/locale/it';
import enLocale from 'date-fns/locale/en-US';

const App: React.FC = () => {
  // useOnPageLeave(() => AuthService().logout());
  const { locale } = useContext(AppContext);
  const dateLocalization = useMemo(() => {
    return locale.locale === "it" ? itLocale : enLocale;
  }, [locale.locale]);

  return (
    <ContextProvider>
      <InfoViewContextProvider>
        <CremaThemeProvider>
          <CremaStyleProvider>
            <LocaleProvider>
              <BrowserRouter>
                <HPAuthRoutes>

                  <CupBookingContextProvider>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={dateLocalization}
                    >

                      <CssBaseline />
                      <AppLayout />

                    </LocalizationProvider>                  
                  </CupBookingContextProvider>
                  
                </HPAuthRoutes>
              </BrowserRouter>
            </LocaleProvider>
          </CremaStyleProvider>
        </CremaThemeProvider>
      </InfoViewContextProvider>
    </ContextProvider>
  );

};

export default App;
